type Context = Record<string, any> & {
  cause?: Error | unknown;
};

class ContextualError extends Error {
  private ctx: Context;

  constructor(message: string, context: Context = {}) {
    super(message, { cause: context.cause });
    this.name = this.constructor.name;
    this.ctx = context;
  }

  get context(): Context {
    return this.ctx;
  }

  set context(context: Context) {
    this.ctx = context;
  }
}

export { ContextualError };
